import { TranslateLoader } from "@ngx-translate/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";


export class CustomLoader implements TranslateLoader {
	private basePath: string = "/assets/i18n";
	constructor(
		private http: HttpClient,
	) {}
	getTranslation(langCountry: string): Observable<any> {
		return this.http.get(`${this.basePath}/${langCountry}.json`);
	}
}
